import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  const [isVideoEnded, setIsVideoEnded] = useState(false);

  return (
    <ContentContext.Provider value={{ isVideoEnded, setIsVideoEnded }}>
      {children}
    </ContentContext.Provider>
  );
};

ContentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useVideo = () => {
  const context = useContext(ContentContext);
  return context;
};
